const assets = {
	ff_list: () => import('./ff_list/ff_list.scss'),
	si_styles: () => import('./ff_scrolling_images/styles.scss'),
	// sample: () => import('./sample/sample'),
	// images_accordion: () => import('./images_accordion/init'),
	// before_after_slider: () => import('./before_after_slider/init'),
	// marquee: () => import('./marquee/init'),
};

if (ff_elementor_asset_loader) {
	ff_elementor_asset_loader.load = load_asset;
	ff_elementor_asset_loader.queue.forEach(load_asset);
}

function load_asset(key) {
	if (assets[key]) assets[key]();
}
